import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import {
  Container, Col, Row,
} from 'ui';
import AdvantageLabel from 'ui/components/AdvantageLabel';
import StepCard from 'ui/components/StepCard';
import WithTornBackground from 'ui/layouts/WithTornBackground';

import s from './SingleTypeLandingAbout.module.scss';

const cx = cn.bind(s);

const letterProps = {
  i: {
    index: 'I',
    color: 'blue',
    title: 'Introverted',
    text: 'Not be afraid to spend time alone and even be energized by it',
  },
  e: {
    index: 'E',
    color: 'blue',
    title: 'Extroverted',
    text: 'Active, energetic, like to talk, entertain, and go on adventures',
  },
  n: {
    index: 'N',
    color: 'orange',
    title: 'Intuitive',
    text: 'Curious minds who think of ideas and possibilities of improving anything',
  },
  s: {
    index: 'S',
    color: 'orange',
    title: 'Sensing',
    text: 'Focus more on facts, figures, and details rather than broad ideas and concepts',
  },
  t: {
    index: 'T',
    color: 'mint',
    title: 'Thinking',
    text: 'Rely on rational facts when making decisions, withhold emotion',
  },
  f: {
    index: 'F',
    color: 'mint',
    title: 'Feeling',
    text: 'Let emotion rule over logic, often relying on your gut when making decisions',
  },
  j: {
    index: 'J',
    color: 'red',
    title: 'Judging',
    text: 'Accesses the world, making quick decision based on available facts',
  },
  p: {
    index: 'P',
    color: 'red',
    title: 'Perceiving',
    text: 'Prefer to do things spontaneously rather than make in-depth plans',
  },
};
const SingleTypeLandingAbout = ({
  children, advantages, disadvantages, description, content, className, letters, type, ...attrs
}) => (
  <section className={cx('section', className)} {...attrs}>
    <WithTornBackground skipContentOffset>
      <Container className={cx('container')}>
        <h2
          className={cx(
            'sectionTitle',
            'tp-mobile-header-2 md:tp-tablet-header-2 xl:tp-header-2 text-center inline-block w-full',
          )}
        >
          What does {type.toUpperCase()} stand for?
        </h2>
        <Row>
          <Col xs={12} md={{ offset: 1, span: 10 }} lg={{ offset: 2, span: 8 }}>
            <p className={cx('tp-text', 'text-center')}>
              { description }
            </p>
          </Col>
        </Row>
        <Row className={cx('sectionStepsRow')}>
          {Object.keys(letters).map((letter) => (
            <Col
              key={letter}
              lg={{ offset: 0, span: 3 }}
              xs={12}
              md={{ offset: 2, span: 8 }}
              className={cx('stepCardCol')}
            >
              <StepCard
                {...letterProps[letter]}
                {...letters[letter]}
              />
            </Col>
          ))}
        </Row>
        <Row>
          <Col lg={{ offset: 2, span: 8 }} md={{ offset: 1, span: 10 }}>
            {content}
          </Col>
        </Row>
        <h2
          className={cx(
            'sectionTitle',
            'advantagesSectionTitle',
            'tp-mobile-header-2 md:tp-header-2',
            'text-center',
          )}
        >
          Common strengths & weaknesses
        </h2>
        <Row>
          <Col
            className={cx('advantageColumn')}
            xs={{ offset: 1, span: 10 }}
            md={{ offset: 1, span: 5 }}
            lg={{ offset: 2, span: 4 }}
            xl={{ offset: 0, span: 6 }}
          >
            {advantages.map((adv) => (
              <AdvantageLabel
                key={adv}
                text={adv}
                className={cx('advantageCardWrapper')}
              />
            ))}
          </Col>
          <Col
            className={cx('advantageColumn')}
            xs={{ offset: 1, span: 10 }}
            md={{ offset: 0, span: 5 }}
            lg={{ offset: 0, span: 4 }}
            xl={6}
          >
            {disadvantages.map((adv) => (
              <AdvantageLabel
                key={adv}
                text={adv}
                negative
                className={cx('advantageCardWrapper')}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </WithTornBackground>
  </section>
);

SingleTypeLandingAbout.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default SingleTypeLandingAbout;
